import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Embed from 'react-music-embed';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Music roundup, September 2019`}</h1>
    <Embed url="https://music.apple.com/us/album/feelings/1479070181?i=1479070182" mdxType="Embed" />
    <Embed url="https://music.apple.com/us/album/stay-over/1475022443?i=1475022650" mdxType="Embed" />
    <Embed url="https://music.apple.com/us/album/purple-hat/1475338013?i=1475338107" mdxType="Embed" />
    <Embed url="https://music.apple.com/us/album/like-this/1475338013?i=1475338110" mdxType="Embed" />
    <Embed url="https://music.apple.com/us/album/chapter-2-ep/1476438198" mdxType="Embed" />
    <Embed url="https://music.apple.com/us/album/fresh-laundry/1478068217?i=1478068219" mdxType="Embed" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      